import { ProfileType } from "@/types";

export type PatientoversiktItem = {
    id: string;
    category: string;
    model: string;
    title: string;
    info: string;
    extra: {
        anmalan?: string;
        fil?: string;
    } | null;
    status: string | null;
    created_at: string;
    due_date: string | null;
    accountableHealthcareProfessional: ProfileType;
};

export type PatientoversiktItemDisplay = PatientoversiktItem & {
    statusIcon: string | null;
    accountableName: string;
};

export enum ModelName {
    Anmalan = "Anmalan",
    Preanestesibedomning = "Preanestesibedomning",
    Operationsjournal = "Operationsjournal",
    Kallelse = "Kallelse",
    SMS = "SMS",
    Fil = "Fil",
}
